module.exports = __webpack_public_path__ + "static/media/showcase9.00d0a9a6.webp";